import { ObservableFromFetch } from "../ObservableFromFetch"

export default function DeleteUser(userName: string) {
  const requestBody: string = new URLSearchParams({ UserName: userName.toString() }).toString()
  return ObservableFromFetch<string>("WorkforceSuperUser/DeleteUser?" + requestBody, "post")
}

export function DeleteRole(applicationUserID: number, participationID: number) {
  const requestBody = JSON.stringify({ ApplicationUserID: applicationUserID, ParticipationID: participationID }).toString()
  return ObservableFromFetch<string>("FFOrderUserFileMaintenance/DeleteRole", requestBody)
}